import { render } from "./App.vue?vue&type=template&id=f9a57e3a"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=f9a57e3a&lang=scss"
script.render = render

export default script